export default function OffScreenPanel({ children, expanded = false, button, direction = 'right' }) {
	return <div className={'off-screen-panel off-screen-panel-' + direction + ' ' + (expanded ? 'off-screen-panel-expanded' : '')}>
		<div className="off-screen-panel-btn-area">
			{button}
		</div>
		<div className="off-screen-panel-content">
			{children}
		</div>
	</div>;
}